<template>
  <modal-card title="Preview HTML Content" fixed full @close="$emit('close')">
    <v-alert
      v-if="isEmptyEmail"
      transition="fade-transition"
      class="ma-4 pa-2"
      type="info"
    >
      <div>Email body is empty</div>
    </v-alert>

    <template v-if="email">
      <div class="spinner-wrap" v-if="loading">
        <spinner />
      </div>
      <iframe
        id="preview-iframe"
        frameborder="0"
        sandbox="allow-popups allow-popups-to-escape-sandbox"
        :srcdoc="previewHtml"
      ></iframe>
    </template>
  </modal-card>
</template>

<script>
import api from '@/factories/api';
import qs from 'qs';

export default {
  name: 'EmailPreviewModal',
  props: {
    email: {},
    messageId: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      previewHtml: '',
    };
  },
  watch: {
    email: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.loadEmailPreview();
        }
      },
    },
  },
  computed: {
    isEmptyEmail() {
      return !this.email?.body && !this.messageId;
    },
  },
  methods: {
    loadEmailPreview() {
      this.previewHtml = '';
      if (!this.email) return;

      let path = '/email/preview?';
      let body = '';

      if (this.email.body) {
        body = qs.stringify({ body: this.email.body || '' });
      }

      if (this.messageId) {
        path += `id=${this.messageId}`;
      }

      if (
        this.email &&
        (this.email.template_id || this.email.id === 'default')
      ) {
        path += `template_id=${this.email.template_id || this.email.id}`;
      }

      this.loading = true;
      api({
        baseURL: '',
        headers: { 'Content-type': 'application/x-www-form-urlencoded' },
      })
        .post(path, body)
        .then((response) => {
          this.loading = false;
          this.previewHtml = response || '';
        });
    },
  },
};
</script>

<style>
#preview-iframe {
  width: 100%;
  height: calc(100% - 10px);
}
</style>
